import { render, staticRenderFns } from "./menutool.vue?vue&type=template&id=2ba51a2c&scoped=true"
import script from "./menutool.vue?vue&type=script&lang=js"
export * from "./menutool.vue?vue&type=script&lang=js"
import style0 from "./menutool.vue?vue&type=style&index=0&id=2ba51a2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba51a2c",
  null
  
)

export default component.exports